<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50">
    <div
      class="bg-white shadow-md rounded-lg overflow-hidden flex flex-col md:flex-row w-full max-w-5xl"
    >
      <!-- Left Section -->
      <div class="w-full md:w-1/2 p-8">
        <PhotoDiagramLogo class="mb-4" />

        <h2 class="text-3xl font-semibold mb-4">Sign in</h2>
        <p class="text-sm text-gray-500 mb-6">Login to your account</p>

        <GoogleSignInButton @click="loginWithGoogle" />

        <div class="flex items-center my-4">
          <div class="flex-grow border-t border-gray-300"></div>
          <span class="px-4 text-gray-500 text-sm">or</span>
          <div class="flex-grow border-t border-gray-300"></div>
        </div>

        <form @submit.prevent="login">
          <input
            type="email"
            placeholder="Email address"
            v-model="email"
            class="w-full border border-gray-300 rounded-lg py-2 px-4 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
          <input
            type="password"
            placeholder="Password"
            v-model="password"
            class="w-full border border-gray-300 rounded-lg py-2 px-4 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
          <p v-if="errorMessage" class="text-red-500 mb-4">
            {{ errorMessage }}
          </p>
          <button
            type="submit"
            class="w-full bg-black text-white rounded-lg py-2 px-4 hover:bg-gray-800"
          >
            Sign in
          </button>
        </form>

        <p class="text-sm text-gray-500 mt-4 text-center">
          Don't have an account?
          <RouterLink
            :to="{ name: 'sign-up' }"
            class="text-blue-500 hover:underline"
            >Sign up</RouterLink
          >
        </p>
        <p class="text-sm text-gray-500 mt-4 text-center">
          <a
            href="https://www.freeprivacypolicy.com/live/dde47b4d-37fe-4846-89b1-7fc605bdedcf"
            target="_blank"
            >Privacy Policy</a
          >
        </p>
      </div>

      <!-- Right Section -->
      <div
        class="hidden md:block w-full md:w-1/2 bg-cover bg-center"
        :style="{
          'background-image': 'url(' + require('@/assets/hero.jpg') + ')',
        }"
      >
        <div
          class="h-full flex flex-col justify-center p-8 bg-black bg-opacity-40 text-white"
        >
          <h3 class="text-2xl font-semibold mb-4">Bring your ideas to life.</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "@/firebase";
import { useRouter } from "vue-router";
import { useMainStore } from "@/store";

import PhotoDiagramLogo from "@/components/PhotoDiagramLogo.vue";
import GoogleSignInButton from "@/components/GoogleSignInButton.vue";

export default {
  name: "SignInPage",
  components: {
    GoogleSignInButton,
    PhotoDiagramLogo,
  },
  setup() {
    const router = useRouter();
    const store = useMainStore();
    return { router, store };
  },
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "", // Add error message data property
    };
  },
  watch: {
    email() {
      this.errorMessage = "";
    },
    password() {
      this.errorMessage = "";
    },
  },
  methods: {
    login() {
      signInWithEmailAndPassword(auth, this.email, this.password)
        .then((userCredential) => {
          this.store.setUser(userCredential.user);
          this.router.push({ name: "home" });
        })
        .catch((error) => {
          if (error.code === "auth/invalid-credential" || error.code === "auth/user-not-found") {
            this.errorMessage = "Invalid email or password."; // Proper error message
          } else {
            this.errorMessage = error.message; // Set error message
          }
        });
    },
  },
};
</script>

<style>
body {
  font-family: Arial, sans-serif;
}
</style>
